var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_029-settings",
    "data-name": "029-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.07,
    height: 83.617,
    viewBox: "0 0 83.07 83.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148",
    transform: "translate(67.093 67.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_253",
    "data-name": "Trazado 253",
    d: "M416.822,411.718a4.324,4.324,0,1,0,4.324,4.324A4.329,4.329,0,0,0,416.822,411.718Zm0,6.085a1.761,1.761,0,1,1,1.761-1.761A1.763,1.763,0,0,1,416.822,417.8Z",
    transform: "translate(-412.498 -411.718)",
    fill: "#86888b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_150",
    "data-name": "Grupo 150",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_149",
    "data-name": "Grupo 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_254",
    "data-name": "Trazado 254",
    d: "M84.74,71.339a11.334,11.334,0,0,0-3.773-8.2l-25.8-23.267L77.979,17.066a2.419,2.419,0,0,0,.441-.176l4.939-2.607a2.405,2.405,0,0,0,.578-3.827L78.376,4.9a2.4,2.4,0,0,0-3.827.578l-2.607,4.939a2.431,2.431,0,0,0-.179.445L61,21.623a1.281,1.281,0,0,0,1.812,1.812l9.879-9.879,2.589,2.589L50.012,41.409,47.423,38.82,58.451,27.792a1.281,1.281,0,0,0-1.812-1.812l-8,8-8.708-7.854A19.676,19.676,0,0,0,14.288,1.3a1.281,1.281,0,0,0-.447,2.1L23.9,13.466a1.575,1.575,0,0,1,0,2.228l-6.532,6.532a1.575,1.575,0,0,1-2.228,0L5.08,12.168a1.281,1.281,0,0,0-2.1.447A19.672,19.672,0,0,0,27.4,38.385l6.733,7.363a6.913,6.913,0,0,1-8.674,3.3,1.281,1.281,0,0,0-1.37.288L8.405,65.022a10.893,10.893,0,0,0,15.4,15.4L39.5,64.739a1.281,1.281,0,0,0,.288-1.37A6.929,6.929,0,0,1,48.755,54.4a1.281,1.281,0,0,0,1.37-.288l2.959-2.959a4.718,4.718,0,0,0,0-6.672l-1.26-1.26,1.532-1.532L79.251,65.044A8.874,8.874,0,1,1,66.758,77.622L47.505,56.568A1.281,1.281,0,1,0,45.614,58.3L64.867,79.351a11.337,11.337,0,0,0,8.184,3.716l.264,0A11.437,11.437,0,0,0,84.74,71.339ZM74.262,11.506l2.453-4.647,5.259,5.259L77.327,14.57ZM28.726,36.034a1.282,1.282,0,0,0-1.393-.336A17.109,17.109,0,0,1,4.756,15.469l8.57,8.57a4.139,4.139,0,0,0,5.852,0l6.532-6.532a4.139,4.139,0,0,0,0-5.852l-8.57-8.571A17.112,17.112,0,0,1,37.235,26.021a1.281,1.281,0,0,0,.332,1.426L46.823,35.8l-1.212,1.212-1.26-1.26a4.718,4.718,0,0,0-6.672,0l-2.959,2.959a1.281,1.281,0,0,0-.288,1.37,6.92,6.92,0,0,1,.463,2.7ZM51.272,49.34l-2.4,2.4a9.5,9.5,0,0,0-9.342,2.407h0a9.5,9.5,0,0,0-2.407,9.343L22,78.614a8.33,8.33,0,0,1-11.78-11.78L25.344,51.708a9.49,9.49,0,0,0,11.75-11.75l2.4-2.4a2.157,2.157,0,0,1,3.048,0l2.166,2.166,4.4,4.4,2.166,2.166A2.157,2.157,0,0,1,51.272,49.34Z",
    transform: "translate(-1.673 0)",
    fill: "#003082"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152",
    transform: "translate(11.912 56.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_255",
    "data-name": "Trazado 255",
    d: "M88.939,344.327a1.282,1.282,0,0,0-1.812,0L74.989,356.464a1.281,1.281,0,0,0,1.812,1.812l12.137-12.137A1.282,1.282,0,0,0,88.939,344.327Z",
    transform: "translate(-74.614 -343.952)",
    fill: "#86888b"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    transform: "translate(16.397 60.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_256",
    "data-name": "Trazado 256",
    d: "M116.4,371.786a1.282,1.282,0,0,0-1.812,0l-12.137,12.137a1.281,1.281,0,0,0,1.812,1.812L116.4,373.6A1.281,1.281,0,0,0,116.4,371.786Z",
    transform: "translate(-102.073 -371.411)",
    fill: "#86888b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.1bc5988e9f56628d02babb96a829c768.svg";
export { ForwardRef as ReactComponent };